import { IconNames } from '@shipengine/giger-theme';
import { Typography } from '../Typography/Typography.js';
import { ButtonSize, ButtonVariant } from '../../utils/buttonStyles.js';
import { getSidePanelHeaderStyles, getSidePanelTitleStyles } from './SidePanelDefaultHeaderStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { ButtonIcon } from '../ButtonIcon/ButtonIcon.js';

const SidePanelDefaultHeader = _ref => {
  let {
    title,
    closeButtonTooltip,
    onClickClose,
    closeAriaLabel,
    ...rest
  } = _ref;
  return jsxs("div", {
    css: getSidePanelHeaderStyles(!!title),
    ...rest,
    children: [jsx(Typography, {
      css: getSidePanelTitleStyles,
      variant: "heading5",
      component: "h5",
      children: title
    }), jsx(ButtonIcon, {
      "aria-label": closeAriaLabel,
      ariaDescribedby: closeButtonTooltip,
      icon: IconNames.CLOSE,
      size: ButtonSize.LARGE,
      variant: ButtonVariant.TEXT,
      onClick: onClickClose,
      children: closeButtonTooltip
    })]
  });
};

export { SidePanelDefaultHeader };
//# sourceMappingURL=SidePanelDefaultHeader.js.map
